export default __webpack_public_path__ + "static/media/infiltration-pond.a3cf4b74.svg";